const downloadFile = async (file, filename = null) => {
  const fileUrl = file.url;
  if (!fileUrl) {
    // Handle empty URL input
    console.error("Error: The file URL is empty.");
    return;
  }

  try {
    // Make the GET request to fetch the file
    const response = await fetch(fileUrl);

    if (response.ok) {
      const blob = await response.blob(); // Creates a blob from the response data
      const url = window.URL.createObjectURL(blob); // Creates a URL for the blob

      // Create an anchor element and programmatically trigger the download
      const anchor = document.createElement("a");
      anchor.href = url;

      // I want to cut what is after .pdf / .xml / .zip in the file name
      // Extract the file extension by splitting based on the last period.
      const extension = file.name
        .substring(file.name.lastIndexOf(".") + 1)
        .toLowerCase();

      // Ensure the extension is one of the supported types (default to "pdf" if not).
      const validExtensions = ["pdf", "xml", "zip"];
      const finalExtension = validExtensions.includes(extension)
        ? extension
        : "pdf";

      // Extract the file name by removing the extension.
      const fileName = file.name.substring(0, file.name.lastIndexOf("."));

      // Decode the file name and append the final extension.
      const decodedFileName =
        decodeURIComponent(fileName) + "." + finalExtension;

      anchor.setAttribute(
        "download",
        filename ? filename : decodedFileName || "fichier_telecharge.pdf"
      );
      document.body.appendChild(anchor);
      anchor.click();

      // Cleanup: Remove the anchor and revoke the object URL
      document.body.removeChild(anchor);
      window.URL.revokeObjectURL(url);
    } else {
      console.error(
        `Error: Failed to download file. Status code: ${response.status}`
      );
    }
  } catch (error) {
    console.error(
      `Error: Failed to download the file. Exception: ${error.message}`
    );
  }
};

export default downloadFile;
